import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { TranslateService } from '@ngx-translate/core';
import { UserService, WindowRef, MenuService, LanguageService, PageService } from '@shared/services';

import { UserQuery } from '@shared/queries';
import { User, ParseObject, Menu, MenuNode, Page, Language } from '@shared/data';

declare var ga: any;
declare var $: any;

@Component({
  moduleId: 'module.id',
  selector: 'web',
  styles: [require('./web.component.scss')],
  template: require('./web.component.html'),
  encapsulation: ViewEncapsulation.None
})
export class WebComponent implements OnInit, AfterViewInit {
  public isOpen: boolean;

  public lang: Observable<string>;
  public navigation: Observable<MenuNode>;
  public footer: Observable<MenuNode>;
  public home: Observable<Page>;
  public cfm: Observable<Map<string, any>>;
  public searchText: string;

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private windowRef: WindowRef,
    private menuService: MenuService,
    private languageService: LanguageService,
    private pageService: PageService) {

  }

  public ngOnInit() {
    let menu = this.menuService.root();

    this.lang = this.languageService.getCurrentLang();
    this.navigation = menu.map(o => o.children.find(v => v.name == MenuNode.NAVIGATION));

    this.footer = menu.switchMap(o => {
      let footer = o.children.find(v => v.name == MenuNode.FOOTER);
      let pages = [];

      footer.children.forEach(v => {
        v.children.forEach(c => {
          if (c.page) {
            pages.push(c.page);
          }
        });
      });

      return ParseObject.rx().fetchAll(pages, {}).map(p => footer);
    });


    this.home = this.pageService.home();

    this.cfm = this.lang.switchMap(lang => {
      return this.home.map(
        page => {
          let map = new Map<string, string>();

          page.customFields.forEach(o => {
            let v = o.value[lang] || o.value[Language.DEFAULT_LANG];

            map.set(o.key, v);
          });

          return map;
        }
      );
    });
  }

  public ngAfterViewInit() {
    var mobileW = 992;
    let content = this.elementRef.nativeElement.querySelector('.ng-sidebar__content');

    Observable.fromEvent(content, 'scroll').subscribe(evt => {
      var winH = content.scrollTop;
      var winW = $(window).width();

      if (winW >= mobileW) {
        var headerTopH = $('.window-only .top-header').height() + $('.header-wrapper').height() + 36;

        if (winH > headerTopH) {

          $('#menu').addClass('sticky animated fadeInDown');

          $('.header-wrapper').removeClass('sticky animated fadeInDown');

        } else {

          $('#menu').removeClass('sticky animated fadeInDown');

        }

      } else {
        var headerTopH = $('.mobile-only .top-header').height() + $('.header-wrapper').height();

        if (winH > headerTopH) {

          $('#menu').removeClass('sticky animated fadeInDown');

          $('.header-wrapper').addClass('sticky animated fadeInDown');

        } else {

          $('.header-wrapper').removeClass('sticky animated fadeInDown');
        }
      }
    });

    this.windowRef.content = content;
  }

  public onMenuClick() {
    this.isOpen = !this.isOpen;
  }

  public onSearch() {
    this.router.navigate(['/search'], { queryParams: {s: this.searchText }});
    this.isOpen = false;
  }

  public getTitle(node: MenuNode, lang: string) {
    return node[MenuNode.TITLE_KEY + '_' + lang] || node[MenuNode.TITLE_KEY + '_' + Language.DEFAULT_LANG];
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/web.component.ts